import { ThreadListPrimitive } from '@assistant-ui/react';
import { Button } from '@mantine/core';
import { IconPlus } from '@tabler/icons-react';

/** Button that creates a new chat thread when clicked. */
export function ThreadListNew() {
  return (
    <ThreadListPrimitive.New asChild>
      <Button leftSection={<IconPlus size={16} />} variant="outline">
        Start new chat
      </Button>
    </ThreadListPrimitive.New>
  );
}
